
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Foundation/stylable/easing.st.css.js";
import "../Input/Input.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_197_0_InputWithTags";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_197_0_InputWithTags__root","text-medium-normal":"wds_1_197_0_StylableTypography__text-medium-normal","inputWrapper":"wds_1_197_0_InputWithTags__inputWrapper","emptyInput":"wds_1_197_0_InputWithTags__emptyInput","selectMode":"wds_1_197_0_InputWithTags__selectMode","inputSuffix":"wds_1_197_0_InputWithTags__inputSuffix","menuArrow":"wds_1_197_0_InputWithTags__menuArrow","statusIndicator":"wds_1_197_0_InputWithTags__statusIndicator","suffixes":"wds_1_197_0_InputWithTags__suffixes","hiddenDiv":"wds_1_197_0_InputWithTags__hiddenDiv","hasMaxHeight":"wds_1_197_0_InputWithTags__hasMaxHeight","customSuffix":"wds_1_197_0_InputWithTags__customSuffix","customPrefix":"wds_1_197_0_InputWithTags__customPrefix","tagsContainer":"wds_1_197_0_InputWithTags__tagsContainer","draggedTag":"wds_1_197_0_InputWithTags__draggedTag","draggedTagPlaceholder":"wds_1_197_0_InputWithTags__draggedTagPlaceholder","input":"wds_1_197_0_InputWithTags__input"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-input-size-large":"--wds-input-size-large","wds-input-size-medium":"--wds-input-size-medium","wds-input-size-small":"--wds-input-size-small","wds-input-size-tiny":"--wds-input-size-tiny","wds-input-padding-vertical-medium":"--wds-input-padding-vertical-medium","wds-input-padding-horizontal-medium":"--wds-input-padding-horizontal-medium","wds-space-100":"--wds-space-100"}; 




